import React, { useRef, useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { Button } from 'primereact/button';
import { SplitButton } from 'primereact/splitbutton';
import { Fieldset } from 'primereact/fieldset';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Menu } from 'primereact/menu';
import axios from "axios";

import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { FileUpload } from 'primereact/fileupload';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";

import { BarrioContext } from "../components/BarrioContext"; // ruta a tu provider
import { descargarComprobantesUnificados } from "../utilities/descargarComprobantes";
import { useAuth } from "../components/AuthContext";
import { useTerminologia } from "../hooks/useTerminologia";
import SummaryStatsCard from "../components/SummaryStatsCard";

import { ProgressSpinner } from 'primereact/progressspinner';


import { Toast } from 'primereact/toast';
import { confirmPopup } from 'primereact/confirmpopup';

const FORMAS_PAGO = [
    { label: 'Efectivo',          value: 1 },
    { label: 'Transferencia',     value: 2 },
    { label: 'Cheque',            value: 3 },
    { label: 'Débito automático', value: 4 },
];

const PAGO_GASTO_EMPTY = {
    fechaPago: new Date(),
    importe: null,
    formaPagoId: null,
    detalle: '',
};

const FORMA_PAGO_PILL_STYLE = {
    1: { icon: 'pi pi-wallet',       bg: '#ecfdf3', color: '#12b76a', border: '#a9efc5' }, // Efectivo
    2: { icon: 'pi pi-sync',         bg: '#eff6ff', color: '#2563eb', border: '#bfdbfe' }, // Transferencia
    3: { icon: 'pi pi-file',         bg: '#fdf2fa', color: '#c11574', border: '#fcceee' }, // Cheque
    4: { icon: 'pi pi-credit-card',  bg: '#f4f3ff', color: '#6938ef', border: '#d9d6fe' }, // Débito automático
};

const formaPagoPillTemplate = (row) => {
    const s = FORMA_PAGO_PILL_STYLE[row.formaPagoId] || { icon: 'pi pi-money-bill', bg: '#f2f4f7', color: '#344054', border: '#d0d5dd' };
    return (
        <span style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            background: s.bg, color: s.color, border: `1px solid ${s.border}`,
            fontWeight: 600, fontSize: '0.75rem', padding: '0.2rem 0.6rem', borderRadius: 99,
        }}>
            <i className={s.icon} style={{ fontSize: '0.7rem' }} />
            {row.formaPago}
        </span>
    );
};

const fmtMoney = (n) => Number(n || 0).toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });
const fmtPercent = (n) => `${Number(n || 0).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;

const Gastos = () => {
    const initialFormData = {
      proveedorId: null,
      comprobante: "",
      detalle: "",
      esPrevision: false,
      esFondoManiobra: false,
      esRestarEmpresaOrdinaria: false,
      esGastoARestarExpensaOrdinaria: false,
      fechaComprobante: new Date(),
      // …otros campos que tengas en `campos`
    };
    const toast = useRef(null);
    const [campos, setCampos] = useState([]);
    //const [formData, setFormData] = useState({});
    const [formData, setFormData] = useState(initialFormData);
    const [opciones, setOpciones] = useState({}); // almacena combos dinámicos
    const [editingId, setEditingId] = useState(null); // null = nuevo, != null = edita


    const { barrio } = useContext(BarrioContext);
    const { administracionId } = useAuth();
    const t = useTerminologia();

    const [visible, setVisible] = useState(false);

    const [selectedDate, setSelectedDate] = useState(new Date());

    const [openDialog, setOpenDialog] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    // ---- Gastos Flash ----
    const [flashVisible, setFlashVisible] = useState(false);
    const [flashProcessing, setFlashProcessing] = useState(false);
    const [flashProgressText, setFlashProgressText] = useState("");
    const [flashQueue, setFlashQueue] = useState([]);
    const [flashIndex, setFlashIndex] = useState(0);
    const [flashHint, setFlashHint] = useState(null);
    const [flashDuplicado, setFlashDuplicado] = useState(null);
    const [guardandoGasto, setGuardandoGasto] = useState(false);
    const [descargandoComprobantes, setDescargandoComprobantes] = useState(false);

     
    const HOST_API = process.env.REACT_APP_URL;
    //const url = `${HOST_API}api/barrios/getBarrios?barrioId=${barrio.barrioId}`;
    const urlParametros = `${HOST_API}api/formulario/getCampos?tipoFormulario=Gastos&barrioId=${barrio.id}&administracionId=${administracionId}`;
    //const urlGastos = `${HOST_API}api/gastoBarrioZaputovich/getByBarrio?barrioId=${barrio.id}&fecha=2025-06-04`;
    const urlGastosDelete = `${HOST_API}api/gastoBarrio/deleteGasto`;
    const urlSaveGastos = `${HOST_API}api/gastoBarrio/saveGasto`;
    
    const excludedCampos = ["proveedorId", "fechaAlta", "usuario", "periodo", "grupoGastoBarrioId"];
    
    const [totalGasto, setTotalGasto] = useState([]);
    const [prevision, setPrevision] = useState([]);
    const [totalPrevision, setTotalPrevision] = useState([]);

    const [gastos, setGastos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [gruposGasto, setGruposGasto] = useState([]);


    const handleGrupoGastoChange = (e) => {
      setFormData({ ...formData, grupoGastoId: e.value });

      const urlProveedores = `${HOST_API}api/proveedores/GetProveedoresCombo?barrioId=${ barrio.id }&administracionId=${administracionId}&grupoGastoId=${ e.value }`;

      console.log("urlProveedores", urlProveedores);

      fetch(urlProveedores)
      
      .then((res) => res.json())
      .then((data) => {
        const normalizado = data.map((p) => ({
          ...p,
          proveedorId: Number(p.proveedorId) // forzar número
        }));
        setProveedores(normalizado);
        console.log("Proveedores normalizados:", normalizado);
      });
    };


    const handleNuevoGasto = () => {
      setEditingId(null);          // modo alta
      setFormData({});             // limpiás el form
      setVisible(true);            // abrís el dialog
    };

    const handleDateChange = (value) => {
      setSelectedDate(value);
    };

    const handleEditarGasto = async (rowData) => {
      setEditingId(rowData.liqGastoId);
      setLoadingBackdrop(true);

      try {
        const url = `${HOST_API}api/gastoBarrio/getById?liqGastoId=${rowData.liqGastoId}&administracionId=${administracionId}`;
        const res = await fetch(url);
        const data = await res.json();

        console.log("✏️ getById:", data);

        setFormData({
          ...initialFormData,
          ...data,
          liqGastoId: data.liqGastoId,
          fecha: data.fecha ? new Date(data.fecha) : null,
          fechaAlta: data.fechaAlta ? new Date(data.fechaAlta) : null,
          fechaComprobante: data.fechaComprobante ? new Date(data.fechaComprobante) : new Date(),
          esPrevision: !!data.esPrevision,
          esFondoManiobra: !!data.esFondoManiobra,
          esRestarEmpresaOrdinaria: !!data.esRestarEmpresaOrdinaria,
        });

        if (data.grupoGastoId) {
          const urlProveedores = `${HOST_API}api/proveedores/GetProveedoresCombo?barrioId=${barrio.id}&administracionId=${administracionId}&grupoGastoId=${data.grupoGastoId}`;
          fetch(urlProveedores)
            .then((res) => res.json())
            .then((provData) => {
              const normalizado = provData.map((p) => ({
                ...p,
                proveedorId: Number(p.proveedorId),
              }));
              setProveedores(normalizado);
            });
        }

        setVisible(true);
      } catch (err) {
        console.error("❌ Error al obtener gasto:", err);
      } finally {
        setLoadingBackdrop(false);
      }
    };  

    const [loadingBackdrop, setLoadingBackdrop] = useState(false);


  const formatDate = (date) => {
    if (!date) return "";

    const year  = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day   = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (guardandoGasto) return; // evita doble submit (doble click / doble Enter)

    if (flashQueue.length > 0 && flashDuplicado) {
      toast.current.show({
        severity: "warn",
        summary: "Gastos Flash",
        detail: "Esta factura parece estar duplicada — saltala o revisala antes de guardar.",
        life: 3000,
      });
      return;
    }

    setGuardandoGasto(true);

    const user = JSON.parse(localStorage.getItem("user"));
    console.log("user",user);
    // Normalizar datos igual que antes
    const payload = {
        ...formData,

        // Fechas en ISO
        fechaAlta: formData.fechaAlta
          ? new Date(formData.fechaAlta).toISOString().split("T")[0] + "T00:00:00"
          : null,
        fecha: formData.fecha
          ? new Date(formData.fecha).toISOString().split("T")[0] + "T00:00:00"
          : null,
        fechaComprobante: formData.fechaComprobante
          ? new Date(formData.fechaComprobante).toISOString().split("T")[0] + "T00:00:00"
          : null,

        // Números parseados
        totalGasto: parseFloat(formData.totalGasto) || 0,
        gastoOrdinario: parseFloat(formData.gastoOrdinario) || 0,
        gastoExtraordinario: parseFloat(formData.gastoExtraordinario) || 0,
        gastoNoDistribuible: parseFloat(formData.gastoNoDistribuible) || 0,

        esPrevision: !!formData.esPrevision,
        esFondoManiobra: !!formData.esFondoManiobra,
        esRestarEmpresaOrdinaria: !!formData.esRestarEmpresaOrdinaria,
        // Checkbox oculto del formulario: se fuerza a false siempre, no se puede tildar desde la UI.
        esGastoARestarExpensaOrdinaria: false,

        grupoGastoBarrioId: formData.grupoGastoId,
        
        barrioId: barrio.id,
        usuarioId: user.id ?? user.usuarioId,

        periodo: selectedDate,
        administracionId
      };

      console.log("Payload:", payload);

      // Armar FormData para el controller
      const formDataToSend = new FormData();
      formDataToSend.append("model", JSON.stringify(payload));

      // Si hay archivo adjunto
      if (formData.archivo) {
        formDataToSend.append("file", formData.archivo);
      }

      try {
        const res = await axios.post(
          `${HOST_API}api/gastoBarrio/saveGasto`,
          formDataToSend,
          // {
          //   headers: { "Content-Type": "multipart/form-data" },
          // }
        );

        console.log("✅ API respondió:", res.data);

        toast.current.show({
          severity: "success",
          summary: "Gastos",
          detail: res.data.message,
          life: 1000,
        });

        if (flashQueue.length > 0) {
          avanzarFlash();
        } else {
          setVisible(false);
          setFormData(initialFormData);
          setProveedores([]);
        }
        fetchGastos();
      } catch (err) {
        toast.current.show({
          severity: "error",
          summary: "Gastos - Error",
          detail: "Error al guardar gasto",
          life: 1000,
        });
        console.error("❌ Error al guardar gasto:", err);
      } finally {
        setGuardandoGasto(false);
      }
  };

  useEffect(() => {
    axios.get(`${HOST_API}api/grupogastos/GetGrupoGastos?administracionId=${administracionId}`)
      .then((res) => setGruposGasto(res.data))
      .catch((err) => console.error("Error al obtener grupos de gasto:", err));
  }, [administracionId]);

 useEffect(() => {
    fetch(urlParametros)
      .then((res) => res.json())
      .then((data) => {
        console.log("urlParametros", data);
        setCampos(data);

        // 🔹 Normalizar valores según tipo de campo
        const inicial = data.reduce((acc, c) => {
          if (c.NombreCampo === "periodo" || c.NombreCampo === "grupoGastoBarrioId") return acc;

          let valor = c.ValorPorDefecto;

          if (!valor) {
            if (c.TipoCampo === "date") {
              valor = null; // 👉 o new Date() si querés la fecha de hoy
            } else if (c.TipoCampo === "number") {
              valor = ""; // string vacío para no romper el input number
            } else {
              valor = ""; // texto vacío por defecto
            }
          } else {
            if (c.TipoCampo === "combo") {
              valor = Number(valor); // casteo id a número
            }
            if (c.TipoCampo === "date") {
              valor = new Date(valor); // paso string a Date
            }
          }

          acc[c.NombreCampo] = valor;
          return acc;
        }, {});

        console.log("🔹 Campos recibidos:", data);
        console.log("🔹 formData inicial:", inicial);

        setFormData(
          {
              ...inicial,
              estadoPagoId: 1, // Pagado por default
              esPrevision: false,
              esFondoManiobra: false,
              esRestarEmpresaOrdinaria: false,
              esGastoARestarExpensaOrdinaria: false,
              fechaComprobante: new Date(),
          }
        );
      })
      .catch((err) => console.error("❌ Error en fetch:", err));

    

    // 2) Traer proveedores desde API
    // const urlProveedores = `${HOST_API}api/proveedores/getProveedores?barrioId=${ barrio.id }}&administracionId=${ '1' }&grupoGastoBarrioId`;
    // fetch(urlProveedores)
    
    // .then((res) => res.json())
    // .then((data) => {
    //   const normalizado = data.map((p) => ({
    //     ...p,
    //     proveedorId: Number(p.proveedorId) // forzar número
    //   }));
    //   setProveedores(normalizado);
    //   console.log("Proveedores normalizados:", normalizado);
    // });
  }, []);

  // handler para actualizar formData
  const handleChange = (campo, valor) => {
    setFormData((prev) => {
      const next = { ...prev, [campo]: valor };
      // El Total del Gasto se replica en Gasto Ordinario
      if (campo === "totalGasto") {
        next.gastoOrdinario = valor;
      }
      return next;
    });
  };

  const handleProveedorChange = (e) => {
    const proveedorId = e.value;

    setFormData((prev) => ({
      ...prev,
      proveedorId: e.value, // guardamos el id seleccionado
    }));

    console.log("✅ Proveedor seleccionado:", proveedorId);
  };

  // ---- Gastos Flash ----

  const cargarFacturaFlashEnForm = (item) => {
    setEditingId(null);
    setFormData({
      ...initialFormData,
      proveedorId: item.proveedorId,
      grupoGastoId: item.grupoGastoId,
      totalGasto: item.monto != null ? item.monto : "",
      gastoOrdinario: item.monto != null ? item.monto : "",
      estadoPagoId: 2, // Pendiente por default
      fechaComprobante: item.fecha || new Date(),
      comprobante: item.nroFactura || "",
      detalle: item.detalle || "",
      archivo: item.file,
    });

    setFlashHint(item.encontrado ? null : { cuit: item.cuit });
    setFlashDuplicado(item.duplicado ? item.duplicadoInfo || {} : null);

    if (item.grupoGastoId) {
      const urlProveedores = `${HOST_API}api/proveedores/GetProveedoresCombo?barrioId=${barrio.id}&administracionId=${administracionId}&grupoGastoId=${item.grupoGastoId}`;
      fetch(urlProveedores)
        .then((res) => res.json())
        .then((data) => {
          const normalizado = data.map((p) => ({ ...p, proveedorId: Number(p.proveedorId) }));
          setProveedores(normalizado);
        });
    } else {
      setProveedores([]);
    }

    setVisible(true);
  };

  const avanzarFlash = () => {
    const nextIndex = flashIndex + 1;
    if (nextIndex < flashQueue.length) {
      setFlashIndex(nextIndex);
      cargarFacturaFlashEnForm(flashQueue[nextIndex]);
    } else {
      setFlashQueue([]);
      setFlashIndex(0);
      setFlashHint(null);
      setFlashDuplicado(null);
      setVisible(false);
      setFormData(initialFormData);
      setProveedores([]);
      toast.current.show({
        severity: "success",
        summary: "Gastos Flash",
        detail: "Se cargaron todas las facturas",
        life: 2000,
      });
    }
  };

  const handleSaltarFlash = () => {
    avanzarFlash();
  };

  const handleProcesarFacturas = async (event) => {
    const files = event.files || [];
    if (files.length === 0) return;

    setFlashProcessing(true);

    const queue = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      setFlashProgressText(`Analizando factura ${i + 1} de ${files.length}…`);

      try {
        const fd = new FormData();
        fd.append("file", file);

        const res = await axios.post(
          `${HOST_API}api/gastoBarrio/analizarFactura?administracionId=${administracionId}&barrioId=${barrio.id}&periodo=${formatDate(selectedDate)}`,
          fd
        );
        const data = res.data;

        queue.push({
          file,
          cuit: data.cuit,
          monto: data.monto,
          fecha: data.fecha ? new Date(data.fecha) : null,
          nroFactura: data.nroFactura || null,
          detalle: data.detalle || null,
          proveedorId: data.proveedorId || null,
          nombreProveedor: data.nombreProveedor || null,
          grupoGastoId: data.grupoGastoId || null,
          encontrado: !!data.encontrado,
          duplicado: !!data.duplicado,
          duplicadoInfo: data.duplicadoInfo || null,
        });
      } catch (err) {
        console.error("❌ Error al analizar factura:", file.name, err);
        toast.current.show({
          severity: "warn",
          summary: "Gastos Flash",
          detail: `No se pudo analizar "${file.name}"`,
          life: 2500,
        });
      }
    }

    // Ademas del duplicado contra lo ya guardado en la base, revisamos que no
    // se haya seleccionado la misma factura dos veces dentro de este mismo lote
    // (todavia no esta guardada ninguna, asi que el backend no lo puede detectar).
    queue.forEach((item, idx) => {
      if (item.duplicado || !item.cuit) return;
      // La fecha leida por OCR no es confiable para comparar (puede venir con dia/mes invertido),
      // asi que alcanza con CUIT + monto; el nro de comprobante suma como señal extra si se detecto.
      const repetidaEnLote = queue.slice(0, idx).some((otro) =>
        otro.cuit === item.cuit && (
          (item.nroFactura && otro.nroFactura && item.nroFactura.trim().toLowerCase() === otro.nroFactura.trim().toLowerCase())
          || (item.monto != null && otro.monto != null && Math.abs(Number(item.monto) - Number(otro.monto)) < 0.01)
        )
      );
      if (repetidaEnLote) {
        item.duplicado = true;
        item.duplicadoInfo = { enEsteLote: true };
      }
    });

    setFlashProcessing(false);
    setFlashProgressText("");
    setFlashVisible(false);
    event.options.clear();

    if (queue.length === 0) {
      toast.current.show({
        severity: "error",
        summary: "Gastos Flash",
        detail: "No se pudo analizar ninguna factura",
        life: 2500,
      });
      return;
    }

    setFlashQueue(queue);
    setFlashIndex(0);
    cargarFacturaFlashEnForm(queue[0]);
  };

const handleDelete = (liqGastoId) => {
  confirmDialog({
    message: '¿Estás seguro de eliminar este gasto?',
    header: 'Confirmación',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Eliminar',
    rejectLabel: 'Cancelar',
    accept: () => deleteGasto(liqGastoId),
  });
};

const deleteGasto = async (liqGastoId) => {
  try {
    const response = await fetch(`${urlGastosDelete}/${liqGastoId}/${administracionId}`, {
      method: "DELETE",
    });

    if (!response.ok) {
      throw new Error("Error al eliminar el gasto");
    }

    setGastos((prev) => prev.filter((g) => g.liqGastoId !== liqGastoId));
  } catch (error) {
    console.error("Error eliminando gasto:", error);
  }
};

// ---- Pagos del Gasto ----
const [pagoDialogVisible, setPagoDialogVisible] = useState(false);
const [pagoLiqGastoId, setPagoLiqGastoId] = useState(null);
const [pagoResumen, setPagoResumen] = useState(null);
const [pagoHistorial, setPagoHistorial] = useState([]);
const [loadingPagos, setLoadingPagos] = useState(false);
const [mostrarFormPago, setMostrarFormPago] = useState(false);
const [pagoEditandoId, setPagoEditandoId] = useState(null);
const [pagoForm, setPagoForm] = useState(PAGO_GASTO_EMPTY);
const [registrandoPago, setRegistrandoPago] = useState(false);

const fetchPagosGasto = useCallback(async (liqGastoId) => {
  setLoadingPagos(true);
  try {
    const res = await axios.get(`${HOST_API}api/pagoGasto/GetPagosGasto`, {
      params: { liqGastoId, administracionId },
    });
    setPagoResumen(res.data.resumen);
    setPagoHistorial(res.data.pagos || []);
  } catch (err) {
    toast.current.show({
      severity: "error",
      summary: "Pagos del Gasto",
      detail: err?.response?.data?.errorDisplay || "No se pudieron obtener los pagos del gasto",
      life: 4000,
    });
  } finally {
    setLoadingPagos(false);
  }
}, [HOST_API, administracionId]);

const handleAbrirRegistrarPago = (row) => {
  setPagoLiqGastoId(row.liqGastoId);
  setPagoResumen(null);
  setPagoHistorial([]);
  setMostrarFormPago(false);
  setPagoEditandoId(null);
  setPagoDialogVisible(true);
  fetchPagosGasto(row.liqGastoId);
};

const handleCerrarPagoDialog = () => {
  if (registrandoPago) return;
  setPagoDialogVisible(false);
  setPagoLiqGastoId(null);
  setPagoResumen(null);
  setPagoHistorial([]);
  setMostrarFormPago(false);
  setPagoEditandoId(null);
};

const handleAbrirNuevoPago = () => {
  setPagoEditandoId(null);
  setPagoForm({
    ...PAGO_GASTO_EMPTY,
    fechaPago: new Date(),
    importe: pagoResumen?.saldoPendiente ?? null,
  });
  setMostrarFormPago(true);
};

const handleEditarPago = (pago) => {
  setPagoEditandoId(pago.pagoGastoId);
  setPagoForm({
    fechaPago: new Date(pago.fechaPago),
    importe: pago.importe,
    formaPagoId: pago.formaPagoId,
    detalle: pago.detalle || "",
  });
  setMostrarFormPago(true);
};

const handleGuardarPago = async () => {
  if (!pagoForm.fechaPago) {
    toast.current.show({ severity: "warn", summary: "Requerido", detail: "Ingrese la fecha de pago", life: 3000 });
    return;
  }
  if (!pagoForm.importe || pagoForm.importe <= 0) {
    toast.current.show({ severity: "warn", summary: "Requerido", detail: "Ingrese el importe del pago", life: 3000 });
    return;
  }
  if (!pagoForm.formaPagoId) {
    toast.current.show({ severity: "warn", summary: "Requerido", detail: "Seleccione la forma de pago", life: 3000 });
    return;
  }

  const user = JSON.parse(localStorage.getItem("user"));

  setRegistrandoPago(true);
  try {
    const payload = {
      pagoGastoId: pagoEditandoId || 0,
      liqGastoId: pagoLiqGastoId,
      fechaPago: formatDate(pagoForm.fechaPago) + "T00:00:00",
      importe: parseFloat(pagoForm.importe) || 0,
      formaPagoId: pagoForm.formaPagoId,
      detalle: pagoForm.detalle || null,
      usuarioId: user?.id ?? user?.usuarioId,
      administracionId,
    };

    await axios.post(`${HOST_API}api/pagoGasto/RegistrarPago`, payload);

    toast.current.show({
      severity: "success",
      summary: "Pago",
      detail: pagoEditandoId ? "Pago actualizado correctamente" : "Pago registrado correctamente",
      life: 2000,
    });
    setMostrarFormPago(false);
    setPagoEditandoId(null);
    await fetchPagosGasto(pagoLiqGastoId);
    fetchGastos();
  } catch (err) {
    toast.current.show({
      severity: "error",
      summary: "Pago - Error",
      detail: err?.response?.data?.errorDisplay || "No se pudo guardar el pago",
      life: 4000,
    });
  } finally {
    setRegistrandoPago(false);
  }
};

const handleAnularPago = (pago) => {
  confirmDialog({
    message: `¿Anular el pago de ${pago.importe.toLocaleString("es-AR", { style: "currency", currency: "ARS" })} del ${new Date(pago.fechaPago).toLocaleDateString("es-AR")}?`,
    header: "Confirmación",
    icon: "pi pi-exclamation-triangle",
    acceptLabel: "Anular",
    rejectLabel: "Cancelar",
    acceptClassName: "p-button-danger",
    accept: async () => {
      try {
        await axios.post(`${HOST_API}api/pagoGasto/AnularPago`, null, {
          params: { pagoGastoId: pago.pagoGastoId, administracionId },
        });
        toast.current.show({ severity: "success", summary: "Pago", detail: "Pago anulado correctamente", life: 2000 });
        await fetchPagosGasto(pagoLiqGastoId);
        fetchGastos();
      } catch (err) {
        toast.current.show({
          severity: "error",
          summary: "Pago - Error",
          detail: err?.response?.data?.errorDisplay || "No se pudo anular el pago",
          life: 4000,
        });
      }
    },
  });
};

const handleDescargarComprobantes = async () => {
  setDescargandoComprobantes(true);
  try {
    const periodoStr = formatDate(selectedDate);
    await descargarComprobantesUnificados({
      gastos,
      hostApi: HOST_API,
      nombreArchivo: `Comprobantes_${barrio?.nombre || "barrio"}_${periodoStr}.pdf`,
      onError: (mensaje, severity = "warn") => {
        toast.current.show({ severity, summary: "Descargar Comprobantes", detail: mensaje, life: 4000 });
      },
    });
  } catch (err) {
    console.error("Error al descargar comprobantes:", err);
    toast.current.show({ severity: "error", summary: "Descargar Comprobantes", detail: "No se pudieron descargar los comprobantes", life: 3000 });
  } finally {
    setDescargandoComprobantes(false);
  }
};




  const getOpcionesCombo = (tablaCombo) => {
    switch (tablaCombo) {
      case "Proveedores":
        return proveedores;
      case "EstadosPago":
        return [
          { id: 2, descripcion: "Pendiente" },
          { id: 1, descripcion: "Pagado" },
        ];
      case "GrupoGastoBase":
        return [
          {id:3, descripcion: "Impuestos y Servicios"},
          {id:7, descripcion: "Seguridad Privada"},
          {id:8, descripcion: "Seguros"},
          {id:4, descripcion: "Mantenimiento y Abonos"},
          {id:5, descripcion: "Reparaciones"},
          {id:2, descripcion: "Gastos Bancarios, Legales, Administrativos y Registrales"},
          {id:1, descripcion: "Aportes y Cargas Sociales"},
          {id:6, descripcion: "Remuneraciones"}
        ];
      default:
        return [];
    }
  };

    const grupos = useMemo(
      () => gruposGasto.reduce((acc, g) => {
        acc[g.grupoGastoId] = g.descripcion;
        return acc;
      }, {}),
      [gruposGasto]
    );

   const fetchGastos = useCallback(async () => {
    if (!selectedDate || !barrio?.id) return;

    setLoadingBackdrop(true);
    try {
      const fecha = formatDate(selectedDate);
      const urlGastos = `${HOST_API}api/gastoBarrio/getByBarrio?barrioId=${barrio.id}&administracionId=${administracionId}&periodo=${fecha}`;

      const response = await axios.get(urlGastos);
      setGastos(response.data);

      const totalRow       = response.data.find(item => item.detalle === "Total");
      const previsionRow   = response.data.find(item => item.detalle === "Previsión");
      const totalPrevision = response.data.find(item => item.detalle === "Total + Previsión");

      if (totalRow) {
        console.log("Total encontrado:", totalRow.totalGasto);
        setTotalGasto(totalRow.totalGasto);
      }
      if (previsionRow) {
        console.log("Previsión encontrada:", previsionRow.gastoOrdinario);
        setPrevision(previsionRow.gastoOrdinario);
      }
      if (totalPrevision) {
        console.log("Total + Previsión encontrado:", totalPrevision.gastoOrdinario);
        setTotalPrevision(totalPrevision.gastoOrdinario);
      }

    } catch (err) {
      setError(err.message || "Error al obtener gastos");
    } finally {
      setLoading(false);
      setLoadingBackdrop(false);
    }
  }, [selectedDate, barrio?.id, administracionId]);

  useEffect(() => {
    fetchGastos();
  }, [fetchGastos]);


    const [proveedores, setProveedores] = useState([]);
    const [estadosPago, setEstadosPago] = useState([]);
    const [barrios, setBarrios] = useState([]);
    //const [grupos, setGrupos] = useState([]);
    const [usuarios, setUsuarios] = useState([]);

    const menu1 = useRef(null);
    const toolbarItems = [
        {
            label: 'Save',
            icon: 'pi pi-check'
        },
        {
            label: 'Update',
            icon: 'pi pi-upload'
        },
        {
            label: 'Delete',
            icon: 'pi pi-trash'
        },
        {
            label: 'Home Page',
            icon: 'pi pi-home'
        }
    ];

    const toolbarLeftTemplate = () => {
        return (
            <>
                <Button label="New" icon="pi pi-plus" style={{ marginRight: '.5em' }} />
                <Button label="Open" icon="pi pi-folder-open" className="p-button-secondary" />

                <i className="pi pi-bars p-toolbar-separator" style={{ marginRight: '.5em' }}></i>

                <Button icon="pi pi-check" className="p-button-success" style={{ marginRight: '.5em' }} />
                <Button icon="pi pi-trash" className="p-button-warning" style={{ marginRight: '.5em' }} />
                <Button icon="pi pi-print" className="p-button-danger" />
            </>
        );
    };


  const estadoPagoTemplate = (rowData) => {
    const map = {
        Pagado:    { bg: '#ecfdf3', color: '#12b76a', border: '#a9efc5' },
        Pendiente: { bg: '#fef3f2', color: '#f04438', border: '#fecdca' },
    };
    const s = map[rowData.estadoPago] || { bg: '#f2f4f7', color: '#667085', border: '#d0d5dd' };
    return (
        <span style={{
            background: s.bg, color: s.color, border: `1px solid ${s.border}`,
            fontWeight: 600, fontSize: '0.75rem', padding: '0.15rem 0.6rem', borderRadius: 99,
        }}>
            {rowData.estadoPago}
        </span>
    );
  };

  const renderTablaPorGrupo = (grupoId) => {
  const filtrados = gastos.filter(g => g.grupoGastoBarrioId === grupoId);
  if (filtrados.length === 0) return null;

  // Filas de resumen
  const subtotalRow   = filtrados.find(r => r.detalle?.trim().startsWith("Subtotal:"));
  const gastosRow     = filtrados.find(r => r.detalle?.trim().startsWith("% Gastos:"));
  const totalRow      = filtrados.find(r => r.detalle?.trim() === "Total");
  const previsionRow  = filtrados.find(r => r.detalle?.trim() === "Previsión");
  const gastosGrupo   = filtrados.find(r => r.detalle?.trim() === "*** % Gastos por Grupo:");

  // Filas que SÍ van a la tabla
  const filasTabla = filtrados.filter(r => {
    const detalle = r.detalle?.trim() || "";
    return !(
      detalle.startsWith("Subtotal:") ||
      detalle.startsWith("% Gastos:") ||
      detalle === "Total" ||
      detalle === "Previsión" ||
      detalle === "*** % Gastos por Grupo:"
    );

  });

  return (
    <Fieldset
      key={grupoId}
      legend={grupos[grupoId]}
      toggleable
      className="mb-4 bg-white fieldset-responsive"
      legendClassName="bg-white"
      style={{ overflow: 'hidden', minWidth: 0 }}
    >
      {/* TABLA */}
      <div style={{ overflowX: 'auto' }}>
      <DataTable
        value={filasTabla}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25]}
        responsiveLayout="scroll"
        emptyMessage="No hay gastos cargados"
        style={{ fontSize: '0.88rem' }}
        tableStyle={{ minWidth: '50rem', width: '100%' }}
      >
        <Column
          field="fechaAlta"
          header="Fecha"
          sortable
          body={(row) => new Date(row.fechaAlta).toLocaleDateString()}
        />
        <Column field="nombreProveedor" header="Proveedor" sortable />
        <Column field="cuit" header="CUIT" sortable />
        <Column field="detalle" header="Detalle" sortable />
        <Column
          field="gastoOrdinario"
          header="Gasto Ordinario"
          sortable
          body={(row) =>
            row.gastoOrdinario.toLocaleString("es-AR", {
              style: "currency",
              currency: "ARS",
            })
          }
        />
        <Column
          field="gastoExtraordinario"
          header="Gasto Extraordinario"
          sortable
          body={(row) =>
            row.gastoExtraordinario.toLocaleString("es-AR", {
              style: "currency",
              currency: "ARS",
            })
          }
        />
        <Column
          field="gastoNoDistribuible"
          header="Gasto No Distribuible"
          sortable
          body={(row) =>
            row.gastoNoDistribuible.toLocaleString("es-AR", {
              style: "currency",
              currency: "ARS",
            })
          }
        />
        <Column
          field="totalGasto"
          header="Total Gasto"
          sortable
          body={(row) =>
            row.totalGasto.toLocaleString("es-AR", {
              style: "currency",
              currency: "ARS",
            })
          }
        />
        <Column field="comprobante" header="Comprobante" sortable />

        <Column
          field="estadoPago"
          header="Estado Pago"
          sortable
          body={estadoPagoTemplate}
        />

        <Column
          header="Acciones"
          style={{ width: "160px", minWidth: "160px" }}
          bodyStyle={{ width: "160px", minWidth: "160px", textAlign: "left" }}
          headerStyle={{ width: "160px", minWidth: "160px" }}
          body={(row) => {
            const detalle = row.detalle?.trim() || "";

            const isResumen =
              detalle.startsWith("Subtotal:") ||
              detalle.startsWith("% Gastos:") ||
              detalle === "Total" ||
              detalle === "Previsión";

            if (isResumen) return null;

            return (
              <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                <Button
                  icon="pi pi-pencil"
                  className="p-button-rounded p-button-success p-button-sm"
                  onClick={() => handleEditarGasto(row)}
                  title="Modificar gasto"
                />

                <Button
                  icon="pi pi-trash"
                  className="p-button-rounded p-button-danger p-button-sm"
                  onClick={() => handleDelete(row.liqGastoId)}
                  title="Eliminar gasto"
                />

                <Button
                  icon="pi pi-dollar"
                  className="p-button-rounded p-button-help p-button-sm"
                  onClick={() => handleAbrirRegistrarPago(row)}
                  title="Registrar pago"
                />

                {row.urlComprobante && (
                  <Button
                    icon="pi pi-file"
                    className="p-button-rounded p-button-info p-button-sm"
                    onClick={() => window.open('backend' + row.urlComprobante, '_blank')}
                    title="Ver comprobante"
                  />
                )}
              </div>
            );
          }}
        />
      </DataTable>
      </div>

      {/* CARDS DE RESUMEN DEBAJO DE LA TABLA */}
      
      <div className="grid mt-3">
        {previsionRow && (
          <div className="col-12 md:col-3">
            <div className="card widget-overview-box widget-overview-box-2">
              <span className="overview-title">Previsión</span>
              <div className="flex justify-content-between">
                <div className="overview-detail flex justify-content-between">
                  <div className="overview-text">
                    {previsionRow.totalGasto.toLocaleString("es-AR", {
                      style: "currency",
                      currency: "ARS",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </div>
                </div>
              </div>
              <img src="assets/layout/images/dashboard/dollar3.svg" alt="value" />
            </div>
          </div>
        )}

        {subtotalRow && (
          <div className="col-12 md:col-6">
            <SummaryStatsCard
              icon="pi pi-wallet"
              title="Subtotal"
              theme="blue"
              items={[
                {
                  label: "Ordinario",
                  value: subtotalRow.gastoOrdinario.toLocaleString("es-AR", { style: "currency", currency: "ARS" }),
                },
                {
                  label: "Extraordinario",
                  value: subtotalRow.gastoExtraordinario.toLocaleString("es-AR", { style: "currency", currency: "ARS" }),
                },
                {
                  label: "No Distribuible",
                  value: subtotalRow.gastoNoDistribuible.toLocaleString("es-AR", { style: "currency", currency: "ARS" }),
                },
              ]}
            />
          </div>
        )}

        {gastosRow && (
          <div className="col-12 md:col-6">
            <SummaryStatsCard
              icon="pi pi-sync"
              title="Gastos"
              theme="green"
              items={[
                {
                  label: "Ordinario",
                  value: `${gastosRow.gastoOrdinario.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`,
                },
                {
                  label: "Extraordinario",
                  value: `${gastosRow.gastoExtraordinario.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`,
                },
                {
                  label: "No Distribuible",
                  value: `${gastosRow.gastoNoDistribuible.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`,
                },
              ]}
            />
          </div>
        )}

        {totalRow && (
          <div className="col-12 md:col-3">
            <div className="card widget-overview-box widget-overview-box-2" style={{ border: "1px solid lightgray" }}>
              <span className="overview-title">Total</span>
              <div className="flex justify-content-between">
                <div className="overview-detail flex justify-content-between">
                  <div className="overview-text">
                    {totalRow.totalGasto.toLocaleString("es-AR", {
                      style: "currency",
                      currency: "ARS",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </div>
                </div>
              </div>
              <img src="assets/layout/images/dashboard/dollar3.svg" alt="value" />
            </div>
          </div>
        )}

        {gastosGrupo && (
          <div className="col-12 md:col-3">
            <div className="card widget-overview-box widget-overview-box-2" style={{ border: "1px solid lightgray" }}>
              <span className="overview-title">Gastos por Grupo</span>
              <div className="flex justify-content-between">
                <div className="overview-detail flex justify-content-between">
                  <div className="overview-text">
                    {gastosGrupo.totalGasto.toLocaleString("es-AR", {
                      style: "currency",
                      currency: "ARS",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </div>
                </div>
              </div>
              <img src="assets/layout/images/dashboard/dollar3.svg" alt="value" />
            </div>
          </div>
        )}
      </div>
    </Fieldset>
  );
};


    if (!barrio?.id) {
      return (
        <div className="flex flex-column align-items-center justify-content-center" style={{ minHeight: '50vh', textAlign: 'center' }}>
          <i className="pi pi-map-marker" style={{ fontSize: '2.5rem', color: '#98a2b3', marginBottom: '1rem' }} />
          <h4 style={{ margin: 0 }}>Seleccioná un {t.barrio}</h4>
          <p style={{ color: '#667085', maxWidth: 360 }}>
            Elegí un {t.barrio} en el selector de la barra superior para ver los gastos.
          </p>
        </div>
      );
    }

    return (
      <>
        <h4>Gastos</h4>
        <br />

      <ConfirmDialog />
      <Toast ref={toast} />
      <Dialog
        visible={loadingBackdrop}
        modal
        closable={false}
        showHeader={false}
        className="backdrop-dialog"
      >
        <ProgressSpinner style={{ width: '60px', height: '60px' }} />
      </Dialog>

    <div className="flex align-items-center gap-3 flex-wrap">

    {/* Botones uno al lado del otro */}
        <div className="flex gap-2 flex-wrap">
              <Button
                  label="Nuevo Gasto"
                  icon="pi pi-plus"
                  onClick={() => setVisible(true)}
              />
              <Button
                  label="Gastos Flash"
                  icon="pi pi-bolt"
                  className="p-button-outlined"
                  onClick={() => setFlashVisible(true)}
              />
              <Button
                  label="Descargar Comprobantes"
                  icon="pi pi-download"
                  className="p-button-outlined"
                  loading={descargandoComprobantes}
                  onClick={handleDescargarComprobantes}
              />
          </div>

          {/* Calendar al lado */}
          <Calendar
              value={selectedDate}
              view="month"
              dateFormat="mm/yy"
              onChange={(e) => handleDateChange(e.value)}
              showIcon
              className="p-inputtext-sm"
          />
      </div>

      <br></br>



        <div className="grid">
            <div className="col-12 md:col-4">
                    <div className="card widget-overview-box widget-overview-box-2" style={{ border: "1px solid lightgray" }}>
                        <span className="overview-title">Total</span>
                        <div className="flex justify-content-between">
                            <div className="overview-detail flex justify-content-between">
                                {/* <div className="overview-badge flex justify-content-center align-items-center">
                                    <i className="pi pi-arrow-up"></i>
                                    <span>4,2%</span>
                                </div> */}
                                <div className="overview-text font-bold">$
                                  {/* {totalGasto} */}
                                {Number(totalGasto).toLocaleString("es-ES")}
                                </div>
                            </div>
                        </div>
                        <img src="assets/layout/images/dashboard/dollar3.svg" alt="value" />
                    </div>
            </div>
            <div className="col-12 md:col-4">
                    <div className="card widget-overview-box widget-overview-box-2" style={{ border: "1px solid lightgray" }}>
                        <span className="overview-title">Previsión</span>
                        <div className="flex justify-content-between">
                            <div className="overview-detail flex justify-content-between">
                                {/* <div className="overview-badge flex justify-content-center align-items-center">
                                    <i className="pi pi-arrow-up"></i>
                                    <span>4,2%</span>
                                </div> */}
                                <div className="overview-text font-bold">$
                                  {Number(prevision).toLocaleString("es-ES")}
                                </div>
                                
                            </div>
                        </div>
                        <img src="assets/layout/images/dashboard/dollar3.svg" alt="value" />
                    </div>
            </div>
            <div className="col-12 md:col-4">
                    <div className="card widget-overview-box widget-overview-box-2" style={{ border: "1px solid lightgray" }}>
                        <span className="overview-title">Total + Previsión</span>
                        <div className="flex justify-content-between">
                            <div className="overview-detail flex justify-content-between">
                                {/* <div className="overview-badge flex justify-content-center align-items-center">
                                    <i className="pi pi-arrow-up"></i>
                                    <span>4,2%</span>
                                </div> */}
                                <div className="overview-text font-bold">$
                                  {/* {totalPrevision} */}
                                {Number(totalPrevision).toLocaleString("es-ES")}
                                </div>
                            </div>
                        </div>
                        <img src="assets/layout/images/dashboard/dollar3.svg" alt="value" />
                    </div>
            </div>
            <Dialog
                header="Gastos Flash — Cargar facturas"
                visible={flashVisible}
                style={{ width: "55vw", minHeight: "60vh" }}
                breakpoints={{ "1200px": "70vw", "960px": "90vw" }}
                modal
                closable={!flashProcessing}
                onHide={() => !flashProcessing && setFlashVisible(false)}
            >
              <p>
                Seleccioná una o varias facturas (PDF o imagen). Se van a analizar
                automáticamente y después las vas a poder revisar y
                confirmar una por una.
              </p>
              {flashProcessing ? (
                <div className="flex flex-column align-items-center gap-3 p-4">
                  <ProgressSpinner style={{ width: "50px", height: "50px" }} />
                  <span>{flashProgressText}</span>
                </div>
              ) : (
                <FileUpload
                  name="facturas"
                  multiple
                  accept=".pdf,.jpg,.jpeg,.png"
                  maxFileSize={5000000}
                  customUpload
                  uploadHandler={handleProcesarFacturas}
                  chooseLabel="Seleccionar facturas"
                  uploadLabel="Procesar Facturas"
                  cancelLabel="Cancelar"
                  emptyTemplate={
                    <div
                      style={{
                        border: "2px dashed #cbd5e1",
                        borderRadius: 10,
                        padding: "4rem 1rem",
                        minHeight: "35vh",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        color: "#667085",
                      }}
                    >
                      <i className="pi pi-cloud-upload" style={{ fontSize: "3rem", color: "#98a2b3" }} />
                      <p style={{ margin: "0.5rem 0 0", fontSize: "1.1rem" }}>
                        Arrastrá y soltá acá tus facturas, o usá el botón "Seleccionar facturas"
                      </p>
                    </div>
                  }
                  style={{ minHeight: "40vh" }}
                />
              )}
            </Dialog>

            <Dialog
                header={
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div style={{
                      width: 34, height: 34, borderRadius: "50%",
                      background: "#7c3aed", color: "#fff",
                      display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                      <i className="pi pi-dollar" />
                    </div>
                    <span>Pagos del Gasto</span>
                  </div>
                }
                visible={pagoDialogVisible}
                style={{ width: "650px" }}
                breakpoints={{ "960px": "92vw" }}
                modal
                closable={!registrandoPago}
                onHide={handleCerrarPagoDialog}
            >
              {loadingPagos ? (
                <div style={{ display: "flex", justifyContent: "center", padding: "2.5rem" }}>
                  <ProgressSpinner style={{ width: 44, height: 44 }} strokeWidth="4" />
                </div>
              ) : pagoResumen && (
                <div>
                  <div style={{ background: "#f9fafb", border: "1px solid #eaecf0", borderRadius: 10, padding: "0.9rem 1.1rem", marginBottom: "1rem" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                      <i className="pi pi-user" style={{ color: "#667085" }} />
                      <span><b>Proveedor:</b> {pagoResumen.proveedor}</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                      <i className="pi pi-file" style={{ color: "#667085" }} />
                      <span><b>Detalle del gasto:</b> {pagoResumen.detalle || "-"}</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <i className="pi pi-dollar" style={{ color: "#667085" }} />
                      <span><b>Total del gasto:</b> {fmtMoney(pagoResumen.totalGasto)}</span>
                    </div>
                  </div>

                  <div style={{ display: "flex", gap: "0.75rem", marginBottom: "1.25rem", flexWrap: "wrap" }}>
                    <div style={{ flex: "1 1 150px", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 10, padding: "0.85rem", textAlign: "center" }}>
                      <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#2563eb", letterSpacing: "0.03em" }}>TOTAL GASTO</div>
                      <div style={{ fontSize: "1.1rem", fontWeight: 700, color: "#1e3a8a", marginTop: 4 }}>{fmtMoney(pagoResumen.totalGasto)}</div>
                    </div>
                    <div style={{ flex: "1 1 150px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10, padding: "0.85rem", textAlign: "center" }}>
                      <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#16a34a", letterSpacing: "0.03em" }}>TOTAL PAGADO</div>
                      <div style={{ fontSize: "1.1rem", fontWeight: 700, color: "#14532d", marginTop: 4 }}>{fmtMoney(pagoResumen.totalPagado)}</div>
                      <div style={{ fontSize: "0.72rem", color: "#16a34a", marginTop: 2 }}>
                        {fmtPercent(pagoResumen.totalGasto ? (pagoResumen.totalPagado / pagoResumen.totalGasto) * 100 : 0)} del total
                      </div>
                    </div>
                    <div style={{ flex: "1 1 150px", background: "#fffaeb", border: "1px solid #fedf89", borderRadius: 10, padding: "0.85rem", textAlign: "center" }}>
                      <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#b54708", letterSpacing: "0.03em" }}>PENDIENTE</div>
                      <div style={{ fontSize: "1.1rem", fontWeight: 700, color: "#92400e", marginTop: 4 }}>{fmtMoney(pagoResumen.saldoPendiente)}</div>
                      <div style={{ fontSize: "0.72rem", color: "#b54708", marginTop: 2 }}>
                        {fmtPercent(pagoResumen.totalGasto ? (pagoResumen.saldoPendiente / pagoResumen.totalGasto) * 100 : 0)} del total
                      </div>
                    </div>
                  </div>

                  <hr style={{ border: "none", borderTop: "1px solid #eaecf0", margin: "0 0 1rem" }} />

                  {mostrarFormPago ? (
                    <div className="p-fluid grid">
                      <div className="col-12">
                        <h5 style={{ margin: "0 0 0.5rem" }}>{pagoEditandoId ? "Editar Pago" : "Nuevo Pago"}</h5>
                      </div>

                      <div className="col-12 md:col-6">
                        <label>Fecha de Pago *</label>
                        <Calendar
                          value={pagoForm.fechaPago}
                          onChange={(e) => setPagoForm((f) => ({ ...f, fechaPago: e.value }))}
                          dateFormat="dd/mm/yy"
                          showIcon
                          className="p-inputtext-sm"
                        />
                      </div>

                      <div className="col-12 md:col-6">
                        <label>Importe *</label>
                        <InputNumber
                          value={pagoForm.importe}
                          onValueChange={(e) => setPagoForm((f) => ({ ...f, importe: e.value }))}
                          mode="currency"
                          currency="ARS"
                          locale="es-AR"
                          className="p-inputtext-sm"
                        />
                      </div>

                      <div className="col-12 md:col-6">
                        <label>Forma de Pago *</label>
                        <Dropdown
                          value={pagoForm.formaPagoId}
                          options={FORMAS_PAGO}
                          onChange={(e) => setPagoForm((f) => ({ ...f, formaPagoId: e.value }))}
                          placeholder="Seleccione"
                          className="p-inputtext-sm w-full"
                        />
                      </div>

                      <div className="col-12 md:col-6">
                        <label>Detalle</label>
                        <InputText
                          type="text"
                          value={pagoForm.detalle}
                          onChange={(e) => setPagoForm((f) => ({ ...f, detalle: e.target.value }))}
                          className="p-inputtext-sm"
                        />
                      </div>

                      <div className="col-12 mt-2 flex gap-2">
                        <Button
                          label={registrandoPago ? "Guardando…" : "Guardar"}
                          icon="pi pi-check"
                          onClick={handleGuardarPago}
                          disabled={registrandoPago}
                          loading={registrandoPago}
                        />
                        <Button
                          label="Cancelar"
                          icon="pi pi-times"
                          className="p-button-text"
                          disabled={registrandoPago}
                          onClick={() => { setMostrarFormPago(false); setPagoEditandoId(null); }}
                        />
                      </div>
                    </div>
                  ) : (
                    <>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: "0.75rem" }}>
                        <i className="pi pi-clock" style={{ color: "#344054" }} />
                        <span style={{ fontWeight: 700 }}>Historial de pagos</span>
                      </div>

                      {pagoHistorial.length === 0 ? (
                        <p style={{ color: "#667085", fontSize: "0.9rem" }}>No hay pagos registrados.</p>
                      ) : (
                        <DataTable value={pagoHistorial} className="p-datatable-sm" style={{ marginBottom: "1rem" }}>
                          <Column field="fechaPago" header="Fecha de pago" body={(r) => new Date(r.fechaPago).toLocaleDateString("es-AR")} />
                          <Column field="importe" header="Importe" body={(r) => fmtMoney(r.importe)} />
                          <Column field="formaPago" header="Forma de pago" body={formaPagoPillTemplate} />
                          <Column field="detalle" header="Detalle" />
                          <Column
                            header="Acciones"
                            style={{ width: "90px" }}
                            body={(r) => (
                              <div style={{ display: "flex", gap: 6 }}>
                                <Button
                                  icon="pi pi-pencil"
                                  className="p-button-rounded p-button-success p-button-sm"
                                  onClick={() => handleEditarPago(r)}
                                  title="Editar pago"
                                />
                                <Button
                                  icon="pi pi-trash"
                                  className="p-button-rounded p-button-danger p-button-sm"
                                  onClick={() => handleAnularPago(r)}
                                  title="Anular pago"
                                />
                              </div>
                            )}
                          />
                        </DataTable>
                      )}

                      {pagoResumen.saldoPendiente <= 0 ? (
                        <div style={{
                          background: "#ecfdf3", border: "1px solid #a9efc5", borderRadius: 8,
                          padding: "0.75rem 1rem", color: "#12b76a", fontWeight: 600, fontSize: "0.9rem",
                        }}>
                          ✓ Gasto completamente pagado
                        </div>
                      ) : (
                        <div style={{
                          background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8,
                          padding: "0.75rem 1rem", color: "#1d4ed8", fontSize: "0.85rem", display: "flex", gap: 8,
                        }}>
                          <i className="pi pi-info-circle" style={{ marginTop: 2 }} />
                          <span>
                            <b>Información importante:</b><br />
                            El gasto se considera totalmente pagado cuando el total pagado sea igual o mayor al total del gasto.
                          </span>
                        </div>
                      )}

                      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "1.25rem" }}>
                        <Button label="Cerrar" className="p-button-text" onClick={handleCerrarPagoDialog} />
                        <Button
                          label="Registrar pago"
                          icon="pi pi-plus"
                          onClick={handleAbrirNuevoPago}
                          disabled={pagoResumen.saldoPendiente <= 0}
                        />
                      </div>
                    </>
                  )}
                </div>
              )}
            </Dialog>

            <Dialog
                header={
                  flashQueue.length > 0
                    ? `Gasto Flash (${flashIndex + 1}/${flashQueue.length}) — revisar y confirmar`
                    : "Nuevo Gasto"
                }
                visible={visible}
                style={{ width: "70vw" }}
                breakpoints={{ "960px": "100vw" }} // responsive en mobile
                modal
                closable={!guardandoGasto}
                onHide={() => {
                  if (guardandoGasto) return;
                  setVisible(false);
                  setFlashQueue([]);
                  setFlashIndex(0);
                  setFlashHint(null);
                  setFlashDuplicado(null);
                }}
            >
            
            <Card className="p-3">
              <form className="p-fluid grid" onSubmit={handleSubmit}>
                {flashDuplicado && (
                  <div
                    className="col-12"
                    style={{
                      background: "#FDECEA",
                      border: "1px solid #F5A9A0",
                      borderRadius: 8,
                      padding: "10px 14px",
                      marginBottom: 8,
                      color: "#8A1F11",
                      fontSize: ".9rem",
                    }}
                  >
                    <b>⚠ Esta factura parece estar duplicada.</b>{" "}
                    {flashDuplicado.enEsteLote
                      ? "Coincide con otra factura de este mismo lote (mismo proveedor, comprobante o fecha e importe)."
                      : `Ya existe un gasto cargado con este proveedor${
                          flashDuplicado.fechaComprobante
                            ? ` del ${new Date(flashDuplicado.fechaComprobante).toLocaleDateString("es-AR")}`
                            : ""
                        }${
                          flashDuplicado.totalGasto != null
                            ? ` por $${Number(flashDuplicado.totalGasto).toLocaleString("es-AR")}`
                            : ""
                        }${flashDuplicado.comprobante ? ` (comprobante ${flashDuplicado.comprobante})` : ""}.`}{" "}
                    No se puede guardar así — revisá los datos o saltá esta factura.
                  </div>
                )}
                {/* 👇 Fila de Dropdowns */}
                <div className="col-12 flex flex-wrap gap-3">
                  {/* Dropdown Proveedor fijo */}

                  <div className="flex-1 min-w-[200px]">
                    <label>Grupo de Gasto *</label>
                    <Dropdown
                      value={formData.grupoGastoId || null}
                      options={gruposGasto}
                      optionValue="grupoGastoId"
                      optionLabel="descripcion"
                      onChange={handleGrupoGastoChange}
                      placeholder="Seleccione"
                      className="p-inputtext-sm w-full"
                    />
                  </div>


                  <div className="flex-1 min-w-[200px]">
                    <label>Proveedor *</label>
                    <Dropdown
                      value={formData.proveedorId || null}
                      options={proveedores}
                      optionValue="proveedorId"
                      optionLabel="nombreProveedor"
                      onChange={handleProveedorChange}
                      placeholder="Seleccione"
                      className="p-inputtext-sm w-full"
                    />
                    {flashHint && (
                      <small className="block mt-1" style={{ color: "#d97706" }}>
                        CUIT detectado: {flashHint.cuit || "no detectado"} (proveedor no
                        encontrado, seleccioná uno o cargalo)
                      </small>
                    )}
                  </div>

                  {/* Resto de dropdowns dinámicos */}
                  {campos
                    .filter(
                      (campo) =>
                        campo.EsCombo && !excludedCampos.includes(campo.NombreCampo)
                    )
                    .sort((a, b) => a.Orden - b.Orden)
                    .map((campo) => (
                      <div key={campo.NombreCampo} className="flex-1 min-w-[200px]">
                        <label>
                          {campo.Label}
                          {campo.EsRequerido && " *"}
                        </label>
                        <Dropdown
                          value={formData[campo.NombreCampo] || null}
                          options={getOpcionesCombo(campo.TablaCombo)}
                          optionValue={campo.CampoValorCombo}
                          optionLabel={campo.CampoTextoCombo}
                          onChange={(e) => handleChange(campo.NombreCampo, e.value)}
                          placeholder="Seleccione"
                          className="p-inputtext-sm w-full"
                        />
                      </div>
                    ))}
                </div>

                {/* 👇 Fila comprobante + detalle */}
                <div className="col-12 flex flex-wrap gap-3 mt-3">
                  <div className="w-full md:w-4">
                    <label>Fecha Comprobante *</label>
                    <Calendar
                      value={formData.fechaComprobante || new Date()}
                      onChange={(e) => handleChange("fechaComprobante", e.value)}
                      dateFormat="dd/mm/yy"
                      showIcon
                      className="p-inputtext-sm w-full"
                    />
                  </div>

                  <div className="w-full md:w-4">
                    <label>Comprobante</label>
                    <InputText
                      type="text"
                      value={formData.comprobante || ""}
                      onChange={(e) => handleChange("comprobante", e.target.value)}
                      className="p-inputtext-sm w-full"
                    />
                  </div>

                  <div className="w-full md:w-4">

                    {/* <input
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={(e) => setFormData({ ...formData, archivo: e.target.files[0] })}
                    /> */}

                    <FileUpload
                      mode="basic"
                      name="archivo"
                      accept=".pdf,.jpg,.jpeg,.png"
                      maxFileSize={5000000} // 5MB
                      chooseLabel="Adjuntar comprobante"
                      onSelect={(e) => setFormData({ ...formData, archivo: e.files[0] })}
                      onClear={() => setFormData({ ...formData, archivo: null })}
                    />

                  </div>

                  <div className="w-full md:w-8">
                    <label>Detalle</label>
                    <InputText
                      type="text"
                      value={formData.detalle || ""}
                      onChange={(e) => handleChange("detalle", e.target.value)}
                      className="p-inputtext-sm w-full"
                    />
                  </div>

                  
                </div>

                {/* 👇 Resto de los campos */}
                {campos
                  .filter(
                    (campo) =>
                      !campo.EsCombo &&
                      !["comprobante", "detalle"].includes(campo.NombreCampo) &&
                      !excludedCampos.includes(campo.NombreCampo)
                  )
                  .sort((a, b) => a.Orden - b.Orden)
                  .map((campo) => (
                    <div key={campo.NombreCampo} className="col-12 md:col-3 lg:col-2">
                      <label>
                        {campo.Label}
                        {campo.EsRequerido && " *"}
                      </label>

                      {campo.TipoCampo === "date" ? (
                        <Calendar
                          value={formData[campo.NombreCampo] || null}
                          onChange={(e) => handleChange(campo.NombreCampo, e.value)}
                          showIcon
                          className="p-inputtext-sm"
                        />
                      ) : (
                        <InputText
                          type={campo.TipoCampo === "number" ? "number" : "text"}
                          value={formData[campo.NombreCampo] || ""}
                          onChange={(e) => handleChange(campo.NombreCampo, e.target.value)}
                          className="p-inputtext-sm"
                        />
                      )}
                    </div>
                  ))}


                {/* Botón guardar */}
                <div className="col-12 mt-3 flex gap-2">
                  <Button
                    label={guardandoGasto ? "Guardando…" : (flashQueue.length > 0 ? "Guardar y Siguiente" : "Guardar")}
                    icon="pi pi-save"
                    type="submit"
                    disabled={guardandoGasto || (flashQueue.length > 0 && !!flashDuplicado)}
                    loading={guardandoGasto}
                  />
                  {flashQueue.length > 0 && (
                    <Button
                      label="Saltar esta factura"
                      icon="pi pi-step-forward"
                      type="button"
                      className="p-button-text"
                      disabled={guardandoGasto}
                      onClick={handleSaltarFlash}
                    />
                  )}
                </div>
              </form>
            </Card>
            </Dialog>

            <div className="col-12" style={{ minWidth: 0, overflow: 'hidden' }}>
              {Object.keys(grupos).map(id => renderTablaPorGrupo(Number(id)))}
            </div>
        </div>


        
        </>
    );
};

export default Gastos;
